import { render } from "./CategoryRoleManagement.vue?vue&type=template&id=17149933&scoped=true"
import script from "./CategoryRoleManagement.vue?vue&type=script&lang=js"
export * from "./CategoryRoleManagement.vue?vue&type=script&lang=js"

import "./CategoryRoleManagement.vue?vue&type=style&index=0&id=17149933&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17149933"]])

export default __exports__